import React, { Dispatch } from 'react';
import { AnyAction } from 'redux';
import { initialState } from './reducer';

export const LocalStoreContext = React.createContext(initialState);
export const LocalDispatchContext = React.createContext<Dispatch<AnyAction>>(
  () => {}
);
